import React, { useState, useEffect } from "react";
import $ from "jquery";
import { AiOutlineLogout, AiFillSave } from "react-icons/ai";

const Profile = (props) => {
  const userData = props.userJson;
  const [cityId, setCityId] = useState(userData.city_id);
  const [stateId, setStateId] = useState(userData.state_id);
  const [imgUrl, setimgUrl] = useState(userData.picture_url);

  useEffect(() => {
    setStateId(props.userJson.state_id);
  }, [props.userJson.state_id]);
  useEffect(() => {
    setCityId(props.userJson.city_id);
  }, [props.userJson.city_id]);
  useEffect(() => {
    if (stateId > 0) props.getCity(stateId);
  }, [stateId]);

  $(".NumberValid").on("input", function() {
    var e = "۰".charCodeAt(0);
    this.value = this.value.replace(/[۰-۹]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    this.value = this.value.replace(/[٠-٩]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    this.value = this.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  });

  $(".valid-empty").on("blur", function() {
    var value_check = $(this).val();
    value_check = value_check.replace(/\s/g, "");
    if (value_check === null || value_check.length < 1) {
      $(this)
        .removeClass("is-valid")
        .addClass("is-invalid");
      $(this)
        .next(".invalid-feedback")
        .text("فیلد نمی تواند خالی باشد.");
      return false;
    }
    $(this)
      .removeClass("is-invalid")
      .addClass("is-valid");
  });

  function checkItem(e) {
    var value_check = $(e).val();
    value_check = value_check.replace(/\s/g, "");
    if (value_check === null || value_check.length < 1) {
      $(e)
        .removeClass("is-valid")
        .addClass("is-invalid");
      $(e)
        .next(".invalid-feedback")
        .text("فیلد نمی تواند خالی باشد.");
      return false;
    }
    $(e)
      .removeClass("is-invalid")
      .addClass("is-valid");
  }
  function submitForm() {
    $(".valid-empty").each(function(i, obj) {
      checkItem($(obj));
    });
    var numItems = $(".is-invalid").length;
    if (numItems === 0) {
      let first_name = $("#User_Fname").val();
      let last_name = $("#User_Lname").val();
      let bank_name = $("#User_BankName").val();
      let bank_shaba = $("#User_BankShaba").val();
      let national_id = $("#User_CodeMeli").val();
      let shop_name = $("#User_StoreName").val();
      let address = $("#User_Address").val();
      let postal_code = $("#User_PostalCode").val();
      let city_id = $("#City_ID").val();
      let text =
        '{ "userForm" : ' +
        '{ "first_name":"' +
        first_name +
        '" , "last_name":"' +
        last_name +
        '"' +
        ',"bank_name":"' +
        bank_name +
        '" , "bank_shaba":"' +
        bank_shaba +
        '"' +
        ',"address":"' +
        address +
        '" , "postal_code":"' +
        postal_code +
        '", "city_id":"' +
        city_id +
        '"' +
        ',"national_id":"' +
        national_id +
        '" , "shop_name":"' +
        shop_name +
        '" }}';
      const myObject = JSON.parse(text);
      props.saveFullProfile(myObject);
      return true;
    }
  }
  function changeCity(evt) {
    setCityId(evt.target.value);
  }
  function changeState(evt) {
    setStateId(evt.target.value);
    props.getCity(evt.target.value);
  }
  function handleFileSelect(evt) {
    if (evt.target.files && evt.target.files.length > 0) {
      let imgSize = evt.target.files[0].size;
      if (imgSize <= 4000000) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const image = reader.result;
          setimgUrl(image);
        });
        reader.readAsDataURL(evt.target.files[0]);
      } else {
        const errorMessage = "حجم فایل نباید بیشتر از 4 مگابایت باشد.";
        props.toggleErrorMessage(errorMessage);
        props.toggleError();
      }
    }
  }
  function getFullname() {
    var displayname = null;
    if (userData.first_name !== null && userData.last_name !== null)
      displayname = userData.first_name + " " + userData.last_name;
    else displayname = userData.mobile;
    return displayname;
  }
  return (
    <div className="Profile">
      <div className="item info dina-bc-blue">
        <div className="file-input">
          <input
            type="file"
            id="inputId"
            className="file"
            accept="image/*"
            onChange={handleFileSelect}
          ></input>
          <label htmlFor="inputId" className="img">
            <img id="userIMG" src={imgUrl} className="img-circle" alt="user" />
          </label>
        </div>
        <p className="text-dark wp-text my-2 text-white">{getFullname()}</p>
        {userData.store_complete !== true ? (
          <input
            type="button"
            className="btn btn-light text-danger rounded-pill"
            value="ثبت کد معرف"
            onClick={() => props.toggleFamiliar()}
          />
        ) : (
          <div className="text-center w-100 wp-text-small mb-2">
            <span className="bg-light p-1 text-danger">اطلاعات معرف</span>{" "}
            <span className="bg-dark p-1">
              {userData.familiar.title} ({userData.familiar.date})
            </span>
          </div>
        )}
      </div>
      <div className="w-100 alert alert-warning wp-text-small rounded-0">
        <div className="input-group mb-1">
          <div className="input-group-prepend">
            <button
              className="btn btn-outline-primary rounded-0"
              type="button"
              onClick={() => {
                navigator.clipboard.writeText(userData.key);
              }}
            >
              کپی
            </button>
          </div>
          <input
            type="text"
            defaultValue={"کد شما: " + userData.key}
            id="key"
            className="form-control form-control-sm wp-input-text rounded-0"
            disabled
          />
        </div>
        <p className="text-justify mb-0">
          تعمیرکار گرامی، از طریق کد فوق سایر تعمیرکاران را زیرمجموعه خود کنید.
        </p>
      </div>
      <div className="item data body-padding-bottom px-2">
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.first_name}
            id="User_Fname"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="1"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام خانوادگی<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.last_name}
            id="User_Lname"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="2"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            موبایل<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.mobile}
            id="User_Mobile"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid"
            tabIndex="3"
            disabled
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            کدملی<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="User_CodeMeli"
            defaultValue={userData.national_id}
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid"
            tabIndex="4"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">نام تعمیرگاه</label>
          <input
            type="text"
            id="User_StoreName"
            defaultValue={userData.shop_name}
            className="form-control form-control-sm wp-input-text rounded-pill "
            tabIndex="5"
          />
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">کدپستی</label>
          <input
            type="text"
            id="User_PostalCode"
            defaultValue={userData.postal_code}
            className="form-control form-control-sm wp-input-text rounded-pill NumberValid"
            tabIndex="6"
          />
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            استان<span className="text-danger mr-1">*</span>
          </label>
          <select
            value={stateId && stateId > 0 ? stateId : 0}
            id="Town_ID"
            name="Town_ID"
            className="form-control form-control-sm rounded-pill wp-input-text valid-empty"
            onChange={changeState}
            tabIndex="7"
          >
            <option value="0">انتخاب نمایید</option>
            {props.town.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            شهر<span className="text-danger mr-1">*</span>
          </label>
          {props.city ? (
            <>
              <select
                value={cityId}
                id="City_ID"
                name="City_ID"
                className="form-control form-control-sm rounded-pill wp-input-text valid-empty"
                tabIndex="8"
                onChange={changeCity}
              >
                <option value="0">ابتدا استان را انتخاب نمایید</option>
                {props.city.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback wp-text-small"></div>
            </>
          ) : null}
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">آدرس</label>
          <textarea
            id="User_Address"
            className="form-control form-control-sm wp-input-text"
            rows="2"
            tabIndex="10"
            defaultValue={userData.address}
          ></textarea>
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام بانک<span className="text-danger mr-1">*</span>
          </label>
          <input
            type="text"
            id="User_BankName"
            defaultValue={userData.bank_name}
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="11"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            شماره شبا<span className="text-danger mr-1">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.bank_shaba}
            id="User_BankShaba"
            className="form-control form-control-sm wp-input-text rounded-pill NumberValid valid-empty"
            tabIndex="12"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <button
            id="SubmitForm"
            className="btn dina-btn-blue rounded-pill float-right"
            onClick={submitForm}
          >
            <AiFillSave /> ثبت اطلاعات
          </button>
          <button
            onClick={() => props.handleLouOut()}
            className="btn dina-btn-orange rounded-pill float-left"
          >
            <AiOutlineLogout /> خروج
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
